import { authRoutes, paths, unauthRoutes } from 'app/routes'
import { UnconfirmedEmailChecker } from 'components/global'
import { matchRoutes, Navigate, useLocation, useRoutes } from 'react-router-dom'

export const AuthApp = () => {
  const location = useLocation()
  const routes = useRoutes(authRoutes)

  if (
    matchRoutes(unauthRoutes, location) &&
    !matchRoutes(authRoutes, location)
  ) {
    return <Navigate to={paths.projects} replace />
  }

  return (
    <>
      {routes}
      <UnconfirmedEmailChecker />
    </>
  )
}
